export default __webpack_public_path__ + "static/media/image_mappcode_2.ab3e854d.png";